/**
 * @file: i18n.js
 * @status: Global Language Engine (V10.4.0) - COMPREHENSIVE UPDATE
 * @authority: @CEO - Abdullah Ahmed Al-Zahrani
 * @description: تحديث شامل لقاموس المصطلحات ليتوافق مع كافة صفحات المنظومة بختم السيادة.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // --- [ Navbar & Navigation ] ---
      "dashboard_title": "Sovereign Industrial Radar",
      "identities_management": "Identity Control Center",
      "finance_radar": "Financing & Liquidity Radar",
      "innovation_depot": "Innovation Inventory",
      "production_radar": "Production Intelligence",
      "invoices_hub": "Sovereign Invoicing Hub",
      "investor_gate": "Investor Gateway",
      "switch_lang": "العربية",
      "logout": "Logout",
      
      // --- [ Shared Sovereignty ] ---
      "ceo_certified": "@CEO Certified",
      "authorized_rank": "Authorized Rank",
      "access_authority": "Access Authority",
      "industrial_loan": "Approved Industrial Loan",
      "localization_rate": "Localization Rate",
      "total_portfolio": "Total Portfolio",
      "active_patents": "Active Patents",
      "ready_production": "Ready for Production",
      "sovereign_seal": "Officially Sealed by @CEO",

      // --- [ Dashboard Pages ] ---
      "impact_students": "STEAM Students",
      "impact_patents": "Patents Inventory",
      "innovation_hours": "Innovation Hours",
      "scientific_trials": "Scientific Trials",
      "infrastructure": "Industrial Infrastructure",
      "localizing_ip": "Localizing Industrial Content (IP)",
      "sovereign_tasks": "Sovereign Tasks",
      "loan_management": "Industrial Loan Management",
      "control_room_btn": "Open Command Center",

      // --- [ Invoices Page ] ---
      "inv_number": "Invoice Number",
      "educational_entity": "Educational Entity",
      "base_amount": "Base Amount",
      "vat_15": "VAT (15%)",
      "sovereign_total": "Sovereign Total",
      "inv_status": "Status",
      "inv_action": "Action",
      "create_inv_btn": "Issue New Invoice"
    }
  },
  ar: {
    translation: {
      // --- [ Navbar & Navigation ] ---
      "dashboard_title": "رادار السيادة الصناعية",
      "identities_management": "إدارة الهويات السيادية",
      "finance_radar": "رادار التمويل والسيولة",
      "innovation_depot": "مخزون الابتكار السيادي",
      "production_radar": "رادار الإنتاج السيادي",
      "invoices_hub": "مركز الفواتير السيادية",
      "investor_gate": "بوابة المستثمرين",
      "switch_lang": "English",
      "logout": "خروج",

      // --- [ Shared Sovereignty ] ---
      "ceo_certified": "معمد بختم @CEO",
      "authorized_rank": "الرتبة المصرحة",
      "access_authority": "صلاحية الوصول",
      "industrial_loan": "القرض الصناعي المعتمد",
      "localization_rate": "معدل توطين التقنية",
      "total_portfolio": "إجمالي محفظة التمويل",
      "active_patents": "الأصول المعرفية النشطة",
      "ready_production": "جاهز للتصنيع",
      "sovereign_seal": "معمد سيادياً بختم @CEO",

      // --- [ Dashboard Pages ] ---
      "impact_students": "طلاب STEAM",
      "impact_patents": "مخزون براءات الاختراع",
      "innovation_hours": "ساعات ابتكار",
      "scientific_trials": "تجارب علمية",
      "infrastructure": "البنية التحتية الصناعية",
      "localizing_ip": "توطين المحتوى الصناعي (IP)",
      "sovereign_tasks": "مهام السيادة",
      "loan_management": "إدارة القرض الصناعي",
      "control_room_btn": "فتح غرفة القيادة",

      // --- [ Invoices Page ] ---
      "inv_number": "رقم الفاتورة",
      "educational_entity": "الجهة التعليمية",
      "base_amount": "المبلغ الأساسي",
      "vat_15": "الضريبة (15%)",
      "sovereign_total": "الإجمالي السيادي",
      "inv_status": "الحالة",
      "inv_action": "إجراء القيادة",
      "create_inv_btn": "إصدار فاتورة جديدة"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ar',
    interpolation: { escapeValue: false }
  });

export default i18n;